function on () {
  var args = arguments
  if (typeof args[0] == 'object') {
    var obj = args[0]
    for (var key in obj) {
      this.on(key, obj[key])
    }
  } else {
    var name = args[0]
    var func = args[1]

    // this.events只是一个实例上的普通属性，它的name属性是一个数组
    // 操作thisEvent就会对这个name属性产生影响（引用类型的复制），
    // 所以on函数的作用是存储一些事件对应的函数，在emit的时候去调用。
    var events = this.events = this.events || {}
    var thisEvent = events[name] = events[name] || []
    thisEvent.push(func)
  }
  return this
}

function once (name, cb) {
  this.on(name, (data) => {
    this.emitted = this.emitted || {}
    if (!this.emitted[name]) {
      cb(data)
      this.emitted[name] = true
    }
  })
  return this
}

function off (name) {
  if (!name) {
    delete this.events
  }

  if (this.events && this.events[name]) {
    delete this.events[name]
  }
  return this
}

function emit (name, ...eventArgs) {
  var self = this
  var events = (this.events && this.events[name]) || []
  events.forEach((func) => {
    func.apply(self, eventArgs)
  })
}

function mixin (target) {
  if (typeof target == 'function') {
    target.prototype.on = on
    target.prototype.once = once
    target.prototype.off = off
    target.prototype.emit = emit
  } else {
    target.on = on
    target.once = once
    target.off = off
    target.emit = emit
  }
}

export default {
  emit: emit,
  mixin: mixin,
  once: once,
  on: on,
  off: off
}



// WEBPACK FOOTER //
// ./src/mods/event.js